import { ThemeFontProperties } from '@sites/site-theme/src/enums/font-properties.enum';
import { ThemeFontTags } from '@sites/site-theme/src/enums/font-tags.enum';

// `color` is never emitted for the `button` tag — buttons take their text colour from the button
// theme, not from typography. `--button-color` exists only to satisfy the strict Record type.
export const THEME_FONTS_VARIABLES: Record<ThemeFontTags, Record<ThemeFontProperties, string>> = {
    [ThemeFontTags.leading]: {
        [ThemeFontProperties.fontFamily]: '--leading-font-family',
        [ThemeFontProperties.fontSize]: '--leading-font-size',
        [ThemeFontProperties.fontStyle]: '--leading-font-style',
        [ThemeFontProperties.fontWeight]: '--leading-font-weight',
        [ThemeFontProperties.lineHeight]: '--leading-line-height',
        [ThemeFontProperties.textTransform]: '--leading-text-transform',
        [ThemeFontProperties.letterSpacing]: '--leading-letter-spacing',
        [ThemeFontProperties.color]: '--leading-color',
    },
    [ThemeFontTags.big]: {
        [ThemeFontProperties.fontFamily]: '--big-font-family',
        [ThemeFontProperties.fontSize]: '--big-font-size',
        [ThemeFontProperties.fontStyle]: '--big-font-style',
        [ThemeFontProperties.fontWeight]: '--big-font-weight',
        [ThemeFontProperties.lineHeight]: '--big-line-height',
        [ThemeFontProperties.textTransform]: '--big-text-transform',
        [ThemeFontProperties.letterSpacing]: '--big-letter-spacing',
        [ThemeFontProperties.color]: '--big-color',
    },
    [ThemeFontTags.small]: {
        [ThemeFontProperties.fontFamily]: '--small-font-family',
        [ThemeFontProperties.fontSize]: '--small-font-size',
        [ThemeFontProperties.fontStyle]: '--small-font-style',
        [ThemeFontProperties.fontWeight]: '--small-font-weight',
        [ThemeFontProperties.lineHeight]: '--small-line-height',
        [ThemeFontProperties.textTransform]: '--small-text-transform',
        [ThemeFontProperties.letterSpacing]: '--small-letter-spacing',
        [ThemeFontProperties.color]: '--small-color',
    },
    [ThemeFontTags.quote]: {
        [ThemeFontProperties.fontFamily]: '--quote-font-family',
        [ThemeFontProperties.fontSize]: '--quote-font-size',
        [ThemeFontProperties.fontStyle]: '--quote-font-style',
        [ThemeFontProperties.fontWeight]: '--quote-font-weight',
        [ThemeFontProperties.lineHeight]: '--quote-line-height',
        [ThemeFontProperties.textTransform]: '--quote-text-transform',
        [ThemeFontProperties.letterSpacing]: '--quote-letter-spacing',
        [ThemeFontProperties.color]: '--quote-color',
    },
    [ThemeFontTags.signature]: {
        [ThemeFontProperties.fontFamily]: '--signature-font-family',
        [ThemeFontProperties.fontSize]: '--signature-font-size',
        [ThemeFontProperties.fontStyle]: '--signature-font-style',
        [ThemeFontProperties.fontWeight]: '--signature-font-weight',
        [ThemeFontProperties.lineHeight]: '--signature-line-height',
        [ThemeFontProperties.textTransform]: '--signature-text-transform',
        [ThemeFontProperties.letterSpacing]: '--signature-letter-spacing',
        [ThemeFontProperties.color]: '--signature-color',
    },
    [ThemeFontTags.p]: {
        [ThemeFontProperties.fontFamily]: '--p-font-family',
        [ThemeFontProperties.fontSize]: '--p-font-size',
        [ThemeFontProperties.fontStyle]: '--p-font-style',
        [ThemeFontProperties.fontWeight]: '--p-font-weight',
        [ThemeFontProperties.lineHeight]: '--p-line-height',
        [ThemeFontProperties.textTransform]: '--p-text-transform',
        [ThemeFontProperties.letterSpacing]: '--p-letter-spacing',
        [ThemeFontProperties.color]: '--p-color',
    },
    [ThemeFontTags.h1]: {
        [ThemeFontProperties.fontFamily]: '--h1-font-family',
        [ThemeFontProperties.fontSize]: '--h1-font-size',
        [ThemeFontProperties.fontStyle]: '--h1-font-style',
        [ThemeFontProperties.fontWeight]: '--h1-font-weight',
        [ThemeFontProperties.lineHeight]: '--h1-line-height',
        [ThemeFontProperties.textTransform]: '--h1-text-transform',
        [ThemeFontProperties.letterSpacing]: '--h1-letter-spacing',
        [ThemeFontProperties.color]: '--h1-color',
    },
    [ThemeFontTags.h2]: {
        [ThemeFontProperties.fontFamily]: '--h2-font-family',
        [ThemeFontProperties.fontSize]: '--h2-font-size',
        [ThemeFontProperties.fontStyle]: '--h2-font-style',
        [ThemeFontProperties.fontWeight]: '--h2-font-weight',
        [ThemeFontProperties.lineHeight]: '--h2-line-height',
        [ThemeFontProperties.textTransform]: '--h2-text-transform',
        [ThemeFontProperties.letterSpacing]: '--h2-letter-spacing',
        [ThemeFontProperties.color]: '--h2-color',
    },
    [ThemeFontTags.h3]: {
        [ThemeFontProperties.fontFamily]: '--h3-font-family',
        [ThemeFontProperties.fontSize]: '--h3-font-size',
        [ThemeFontProperties.fontStyle]: '--h3-font-style',
        [ThemeFontProperties.fontWeight]: '--h3-font-weight',
        [ThemeFontProperties.lineHeight]: '--h3-line-height',
        [ThemeFontProperties.textTransform]: '--h3-text-transform',
        [ThemeFontProperties.letterSpacing]: '--h3-letter-spacing',
        [ThemeFontProperties.color]: '--h3-color',
    },
    [ThemeFontTags.h4]: {
        [ThemeFontProperties.fontFamily]: '--h4-font-family',
        [ThemeFontProperties.fontSize]: '--h4-font-size',
        [ThemeFontProperties.fontStyle]: '--h4-font-style',
        [ThemeFontProperties.fontWeight]: '--h4-font-weight',
        [ThemeFontProperties.lineHeight]: '--h4-line-height',
        [ThemeFontProperties.textTransform]: '--h4-text-transform',
        [ThemeFontProperties.letterSpacing]: '--h4-letter-spacing',
        [ThemeFontProperties.color]: '--h4-color',
    },
    [ThemeFontTags.pre]: {
        [ThemeFontProperties.fontFamily]: '--pre-font-family',
        [ThemeFontProperties.fontSize]: '--pre-font-size',
        [ThemeFontProperties.fontStyle]: '--pre-font-style',
        [ThemeFontProperties.fontWeight]: '--pre-font-weight',
        [ThemeFontProperties.lineHeight]: '--pre-line-height',
        [ThemeFontProperties.textTransform]: '--pre-text-transform',
        [ThemeFontProperties.letterSpacing]: '--pre-letter-spacing',
        [ThemeFontProperties.color]: '--pre-color',
    },
    [ThemeFontTags.button]: {
        [ThemeFontProperties.fontFamily]: '--button-font-family',
        [ThemeFontProperties.fontSize]: '--button-font-size',
        [ThemeFontProperties.fontStyle]: '--button-font-style',
        [ThemeFontProperties.fontWeight]: '--button-font-weight',
        [ThemeFontProperties.lineHeight]: '--button-line-height',
        [ThemeFontProperties.textTransform]: '--button-text-transform',
        [ThemeFontProperties.letterSpacing]: '--button-letter-spacing',
        [ThemeFontProperties.color]: '--button-color',
    },
};

export const THEME_FONTS_VARIABLES_TABLET = {
    [ThemeFontTags.leading]: {
        [ThemeFontProperties.fontFamily]: '--leading-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--leading-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--leading-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--leading-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--leading-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--leading-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--leading-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--leading-color-tablet',
    },
    [ThemeFontTags.big]: {
        [ThemeFontProperties.fontFamily]: '--big-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--big-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--big-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--big-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--big-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--big-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--big-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--big-color-tablet',
    },
    [ThemeFontTags.small]: {
        [ThemeFontProperties.fontFamily]: '--small-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--small-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--small-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--small-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--small-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--small-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--small-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--small-color-tablet',
    },
    [ThemeFontTags.quote]: {
        [ThemeFontProperties.fontFamily]: '--quote-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--quote-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--quote-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--quote-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--quote-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--quote-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--quote-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--quote-color-tablet',
    },
    [ThemeFontTags.signature]: {
        [ThemeFontProperties.fontFamily]: '--signature-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--signature-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--signature-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--signature-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--signature-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--signature-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--signature-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--signature-color-tablet',
    },
    [ThemeFontTags.p]: {
        [ThemeFontProperties.fontFamily]: '--p-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--p-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--p-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--p-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--p-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--p-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--p-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--p-color-tablet',
    },
    [ThemeFontTags.h1]: {
        [ThemeFontProperties.fontFamily]: '--h1-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--h1-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--h1-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--h1-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--h1-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--h1-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--h1-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--h1-color-tablet',
    },
    [ThemeFontTags.h2]: {
        [ThemeFontProperties.fontFamily]: '--h2-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--h2-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--h2-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--h2-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--h2-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--h2-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--h2-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--h2-color-tablet',
    },
    [ThemeFontTags.h3]: {
        [ThemeFontProperties.fontFamily]: '--h3-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--h3-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--h3-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--h3-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--h3-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--h3-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--h3-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--h3-color-tablet',
    },
    [ThemeFontTags.h4]: {
        [ThemeFontProperties.fontFamily]: '--h4-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--h4-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--h4-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--h4-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--h4-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--h4-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--h4-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--h4-color-tablet',
    },
    [ThemeFontTags.pre]: {
        [ThemeFontProperties.fontFamily]: '--pre-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--pre-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--pre-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--pre-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--pre-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--pre-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--pre-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--pre-color-tablet',
    },
    [ThemeFontTags.button]: {
        [ThemeFontProperties.fontFamily]: '--button-font-family-tablet',
        [ThemeFontProperties.fontSize]: '--button-font-size-tablet',
        [ThemeFontProperties.fontStyle]: '--button-font-style-tablet',
        [ThemeFontProperties.fontWeight]: '--button-font-weight-tablet',
        [ThemeFontProperties.lineHeight]: '--button-line-height-tablet',
        [ThemeFontProperties.textTransform]: '--button-text-transform-tablet',
        [ThemeFontProperties.letterSpacing]: '--button-letter-spacing-tablet',
        [ThemeFontProperties.color]: '--button-color-tablet',
    },
};

export const THEME_FONTS_VARIABLES_MOBILE = {
    [ThemeFontTags.leading]: {
        [ThemeFontProperties.fontFamily]: '--leading-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--leading-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--leading-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--leading-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--leading-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--leading-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--leading-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--leading-color-mobile',
    },
    [ThemeFontTags.big]: {
        [ThemeFontProperties.fontFamily]: '--big-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--big-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--big-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--big-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--big-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--big-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--big-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--big-color-mobile',
    },
    [ThemeFontTags.small]: {
        [ThemeFontProperties.fontFamily]: '--small-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--small-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--small-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--small-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--small-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--small-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--small-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--small-color-mobile',
    },
    [ThemeFontTags.quote]: {
        [ThemeFontProperties.fontFamily]: '--quote-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--quote-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--quote-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--quote-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--quote-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--quote-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--quote-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--quote-color-mobile',
    },
    [ThemeFontTags.signature]: {
        [ThemeFontProperties.fontFamily]: '--signature-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--signature-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--signature-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--signature-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--signature-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--signature-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--signature-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--signature-color-mobile',
    },
    [ThemeFontTags.p]: {
        [ThemeFontProperties.fontFamily]: '--p-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--p-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--p-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--p-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--p-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--p-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--p-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--p-color-mobile',
    },
    [ThemeFontTags.h1]: {
        [ThemeFontProperties.fontFamily]: '--h1-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--h1-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--h1-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--h1-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--h1-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--h1-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--h1-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--h1-color-mobile',
    },
    [ThemeFontTags.h2]: {
        [ThemeFontProperties.fontFamily]: '--h2-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--h2-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--h2-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--h2-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--h2-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--h2-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--h2-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--h2-color-mobile',
    },
    [ThemeFontTags.h3]: {
        [ThemeFontProperties.fontFamily]: '--h3-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--h3-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--h3-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--h3-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--h3-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--h3-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--h3-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--h3-color-mobile',
    },
    [ThemeFontTags.h4]: {
        [ThemeFontProperties.fontFamily]: '--h4-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--h4-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--h4-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--h4-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--h4-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--h4-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--h4-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--h4-color-mobile',
    },
    [ThemeFontTags.pre]: {
        [ThemeFontProperties.fontFamily]: '--pre-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--pre-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--pre-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--pre-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--pre-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--pre-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--pre-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--pre-color-mobile',
    },
    [ThemeFontTags.button]: {
        [ThemeFontProperties.fontFamily]: '--button-font-family-mobile',
        [ThemeFontProperties.fontSize]: '--button-font-size-mobile',
        [ThemeFontProperties.fontStyle]: '--button-font-style-mobile',
        [ThemeFontProperties.fontWeight]: '--button-font-weight-mobile',
        [ThemeFontProperties.lineHeight]: '--button-line-height-mobile',
        [ThemeFontProperties.textTransform]: '--button-text-transform-mobile',
        [ThemeFontProperties.letterSpacing]: '--button-letter-spacing-mobile',
        [ThemeFontProperties.color]: '--button-color-mobile',
    },
};
